<template>
  <div>
    <loading :loading="loading"></loading>
    <activity-redirect-to-office></activity-redirect-to-office>
  </div>
</template>

<script>
import ActivityNavigator, {Activities} from "./utils/ActivityNavigator";
import UrlParams from "./data/model/UrlParams";
import PartnerAppParam from "./data/model/PartnerAppParam";
import EzUtils from "./utils/EzUtils";
import DataSource from "./data/DataSource";
import CoBrandingDataHolder from "./data/model/CoBrandingDataHolder";
import Loading from "./components/layout/Loading";
import LoanScopeDataHolder from "./data/model/LoanScopeDataHolder";
import ActivityRedirectToOffice from "./components/layout/ActivityRedirectToOffice";

const MERCHANT = "MERCHANT";

export default {
  name: "Launch",

  components: {Loading, ActivityRedirectToOffice},

  data: () => ({
    loading: false,
  }),

  created() {
    PartnerAppParam.clearPartnerAppData();
    UrlParams.clearUrlData();
    LoanScopeDataHolder.clearLoanScopeData();
    CoBrandingDataHolder.clearEzCredJourneyType();

    UrlParams.setMerchantID(this.getUrlParam("mId") || this.getUrlParam("mID"));

    UrlParams.setEntity(this.getUrlParam("entity"));

    UrlParams.setMobile(this.getUrlParam("mobile"));
    UrlParams.setOTP(this.getUrlParam("otp"));

    UrlParams.setLoanAccountNumber(
        this.getUrlParam("aId") || this.getUrlParam("aID")
    );

    UrlParams.setLeadId(this.getUrlParam("leadId"));

    try {
      //checking if this link is opened through partner app with javascript interface with name partnerCallback
      // eslint-disable-next-line no-undef
      if (partnerCallback) {
        PartnerAppParam.setPartnerAppCallback(true);
        PartnerAppParam.setPartnerCallbackWithJavaScriptInterface(true);
      }
    } catch {
      //checking if this link is opened through partner app with param enablePartnerCallback
      PartnerAppParam.setPartnerCallbackWithJavaScriptInterface(false);
      if (this.getUrlParam("enablePartnerCallback") === "true") {
        PartnerAppParam.setPartnerAppCallback(true);
      }
    }

    //if mobile number is not empty, set is to LoanScopeDataHolder, 
    //To pre poulate for customerPhoneNumber page
    if (UrlParams.getMobile()) {
      LoanScopeDataHolder.setMobile(UrlParams.getMobile());
    }

    if (UrlParams.getEntity()) {
      LoanScopeDataHolder.setLeadEntity(UrlParams.getEntity());
    }

    //if aId is not empty do not show landing and welcome page, redirect to login page
    if (UrlParams.getLoanAccountNumber()) {
      LoanScopeDataHolder.setLoanAccountNumber(UrlParams.getLoanAccountNumber());
      ActivityNavigator.navigateTo(Activities.LOGIN);
      return;
    }

    //Dealer Onboarding Welcome page - cobranding
    if (UrlParams.getLeadId() && EzUtils.isValidId(UrlParams.getLeadId())) {
      this.setCoBrandingData("", UrlParams.getLeadId(),null,null);
      return;
    }

    //If mID is not empty fetch cobranding logo and text
    if (UrlParams.getMerchantID()) {
      this.processCobrandingLogo();
    } else {//Default view
      this.setCoBrandingData("", null,null,null);
    }

  },

  methods: {
    getUrlParam(key) {
      const currentPageUrl = location ? location.href : null;
      return EzUtils.getParamFromUrl(key, currentPageUrl);
    },

    processCobrandingLogo() {
      this.loading = true;
      DataSource.getRetailerDetailsFromExternalId(
          UrlParams.getMerchantID()
      ).then((retailerConfigRes) => {
        if (!retailerConfigRes.errorOccurred) {
          const retailerConfigDetails = retailerConfigRes.data;
          this.setCoBrandingData(retailerConfigDetails.retailerName,null,UrlParams.getMerchantID(),null);
        } else {
          this.loading = false;
          ActivityNavigator.navigateTo(Activities.WELCOME);
        }
      });
    },

    setCoBrandingData(retailerName, leadId, mId, aId) {
      let requestBody = {};
      requestBody.retailerName = retailerName;
      if(mId){
        requestBody.officeExternalId = mId;
      }
      if(aId){
        requestBody.aId = aId;
      }
      if(leadId){
        requestBody.leadId = leadId;
      }
      DataSource.getPublicRetailerConfig(requestBody, leadId)
      .then(
          (partnerConfigRes) => {
            this.loading = false;
            if (!partnerConfigRes.errorOccurred) {
              CoBrandingDataHolder.setCoBrandingData(partnerConfigRes.data);
              ActivityNavigator.navigateTo(Activities.WELCOME);
            } else {
              ActivityNavigator.navigateTo(Activities.WELCOME);
            }
          }
      );
    }
  }
};
</script>

<style scoped></style>
